<template>
  <div class="lottery">
    <div class="swiper">
      <bubble-comp></bubble-comp>
    </div>
    <Progress />
    <div class="wrap">
      <xes-lottery-square
        ref="lotterySquare"
        :config="lotteryConfig"
        :awardList="awardList"
        :awardIndex="awardIndex"
        :isStart="isStart"
        :drawNum="drawNum"
        :isloading="isNewLoading"
        :showTips="showTips"
        @startDraw="startDraw"
        @onComplete="onComplete"
      />
        <popup-luck ref="popupLuck" :awardInfo="luckInfo" @shareposter="sharePoster" :userId="userId" :desc="desc" :offline="offline"></popup-luck>
      </div>
    <div class="prizeinfo">
      <div @click="gotoMyPrize"></div>
    </div>

    <SharePoster ref="poster" :type="posterType" />
  </div>
</template>

<script>
import lotterySquare from '@/common/components/lotterySquare'
import SharePoster from '@/summerCamp/components/sharePoster'
import resolveUrl from '@/common/utils/resolveUrl'
import { mapActions, mapState } from 'vuex'
import PopupLuck from '../popupLuck.vue'
import BubbleComp from './bubble.vue'
import Progress from './progress.vue'
import { MYPRIZEPAGE, SHARE } from '../../const'
export default {
  name: 'righting',
  components: {
    'xes-lottery-square': lotterySquare,
    'popup-luck': PopupLuck,
    'bubble-comp': BubbleComp,
    SharePoster,
    Progress
  },
  props: {
    userId: {
      type: String
    },
    isAward: {
      type: Boolean
    },
    isShenhe: {
      type: Boolean
    },
    offline: {
      type: Boolean
    }
  },
  watch: {
    drawNum: {
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.setPointerImage(val)
        }
        this.isDrawNumLoading = false
      },
      immediate: true
    },
    userId(val) {
      if (val) {
        this.userId = val
      }
    }

  },
  data() {
    return {
      awardList: new Array(8).fill({
        background: 'https://editor.xesimg.com/tailor/resource/lottery-normal-1622105385907.png'
      }),
      awardIndex: '',
      isStart: false,
      posterType: 2, // 分享活动
      luckInfo: {
        pic: '',
        type: -1 // 1需要填地址的实物奖，3赠课卡，5金币
      },
      luckDrawUrl: 'https://editor.xesimg.com/tailor/resource/luckDraw-1622709124403.png', // 开始抽奖按钮
      noLuckDrawNumUrl: 'https://editor.xesimg.com/tailor/resource/no-luck-1622709124404.png', // 无抽奖次数按钮
      finishDrawUrl: 'https://editor.xesimg.com/tailor/resource/final-lottery-1628752387086.png',
      noShareDrawUrl: 'https://editor.xesimg.com/tailor/resource/final-poster-1628752387087.png',
      lotteryConfig: {
        model: 'circle',
        background: 'transparent',
        pointerImage: ''
      },
      isDraw: false,
      isloading: true,
      desc: '',
      showTips: false,
      rewardData: {},
      isDrawNumLoading: true
    }
  },
  created() {
    this.init()
    this.sourceId =
      window._wltfChannel.urlParams.xeswx_sourceid ||
      window._wltfChannel.hotUrlParams.source ||
      window._wltfChannel.urlParams.sourceid ||
      window._wltfChannel.urlParams.sourceId ||
      ''
  },
  computed: {
    ...mapState(['sGroupId', 'drawNum']),
    isNewLoading() {
      // 获取奖品列表并且抽奖button状态都OK，才隐藏loading
      return this.isloading || this.isDrawNumLoading
    }
  },
  methods: {
    ...mapActions(['getDrawNum']),
    init() {
      console.log('draw', this.drawNum)
      // this.setPointerImage(this.drawNum)
      this.getprizeList()
    },
    // 获取奖池列表
    async getprizeList() {
      try {
        const res = await this.$api.getList({
          sGroupId: this.sGroupId,
          userId: this.userId || this.$xesCookie.get('stu_id')
        })
        if (res.code === 0) {
          const awardList = res.data.viewList
          this.awardList = new Array(8).fill({
            background: 'https://editor.xesimg.com/tailor/resource/lottery-normal-1622105385907.png'
          })
          awardList.forEach((item, index) => {
            const { id, rewardId, rewardImage, rewardName } = item
            // this.awardList.push({
            //   picture: rewardImage,
            //   id: id,
            //   name: rewardName,
            //   rewardId: rewardId,
            //   background: 'https://editor.xesimg.com/tailor/resource/lottery-normal-1622105385907.png'
            // })
            this.awardList[index] = {
              picture: rewardImage,
              id: id,
              name: rewardName,
              rewardId: rewardId,
              background:
                'https://editor.xesimg.com/tailor/resource/lottery-normal-1622105385907.png'
            }
          })
        } else {
          this.awardList = new Array(8).fill({
            background: 'https://editor.xesimg.com/tailor/resource/lottery-normal-1622105385907.png'
          })
        }
        this.isloading = false
        console.log(this.awardList)
      } catch (e) {}
    },
    gotoMyPrize() {
      // 我的奖品
      this.$xesLogger.clickMsg({
        params: {
          clickid: 19,
          action: 'click',
          elemname: '点击查看我的奖品'
        }
      })

      const _url = resolveUrl(MYPRIZEPAGE, {
        sGroupId: this.sGroupId,
        userId: this.userId || ''
        // env: 'sandbox'
      })
      setTimeout(() => {
        window.location.href = _url
      }, 300)
    },
    handleShare() {
      // 将登陆cookie带过去
      const tal_token = this.$xesCookie.get('tal_token')
      const URL = `${SHARE}?sourceId=${this.sourceId}&tal_token=${tal_token}&titleBarType=2`
      setTimeout(() => {
        location.href = URL
      }, 300)
    },
    startDraw() {
      if (this.offline) {
        this.$toast('活动已结束！')
        return false
      }
      // this.startDrawNext()
    },
    /**
     * 开始抽奖
     */
    async startDrawNext() {
      if (this.drawNum <= 0) {
        console.log('draw', this.drawNum)
        // 没有抽奖次数/资格
        this.lotteryConfig.pointerImage = this.noLuckDrawNumUrl

        this.$xesLogger.clickMsg({
          params: {
            clickid: 15,
            action: 'click',
            elemname: '点击获取更多抽奖机会'
          }
        })

        // 到分享海报页
        this.handleShare()
        return
      }

      // 处于抽奖过程中
      if (this.isStart) {
        return
      }
      if (this.isDraw) {
        return
      }
      this.isDraw = true

      this.$xesLogger.clickMsg({
        params: {
          clickid: 14,
          action: 'click',
          elemname: '点击抽奖'
        }
      })
      // 刷新奖池
      this.isloading = true
      await this.getprizeList()
      // 有抽奖次数 开始抽奖
      try {
        const res = await this.$api.getReward({
          sGroupId: this.sGroupId,
          userId: this.userId || this.$xesCookie.get('stu_id'),
          sourceId: this.sourceId
        })

        if (res.code === 0) {
          this.isStart = true
          const { rewardData, nextNum } = res.data
          this.setLuckDrawInfo(rewardData)
          const idx = this.awardList.findIndex((el) => el.rewardId === rewardData.rewardId)
          const resDraw = await this.getDrawNum({
            userId: this.userId || this.$xesCookie.get('stu_id')
          })
          this.rewardData = resDraw
          // this.desc = [2, 4, 7].includes(+nextNum) ? '下次抽奖必中实物' : '此次分享不额外增加抽奖机会'
          if ([2, 4, 7].includes(+nextNum)) {
            this.desc = '下次抽奖必中实物'
            this.showTips = !this.offline
          } else {
            this.desc = '分享到朋友圈更容易中奖哦'
            this.showTips = false
          }
          this.$xesLogger.clickMsg({
            params: {
              clickid: 22,
              elemname: '中奖弹窗信息',
              nextNum: nextNum,
              desc: this.desc,
              showTips: this.showTips,
              rewardData: JSON.stringify(rewardData)
            }
          })

          setTimeout(() => {
            this.awardIndex = this.awardList[idx].id
            // this.drawNum = resDraw.currentNum
            this.$store.commit('setDrawNum', resDraw.currentNum)
            // this.onComplete()
          }, 3000)
        } else {
          this.$toast(res.msg || '请求错误')
          const resDraw = await this.getDrawNum({
            userId: this.userId || this.$xesCookie.get('stu_id')
          })
          // this.drawNum = resDraw.currentNum
          this.$store.commit('setDrawNum', resDraw.currentNum)
          this.isStart = false
        }
        this.isDraw = false
      } catch (e) {}
    },
    onComplete() {
      this.$refs.popupLuck.isShowLuckResultPop = true
      // this.$refs.lotterySquare.curGameIdx = -1
      this.$store.commit('setLotteryNum', this.rewardData.usdNum)
      this.$xesLogger.clickMsg({
        params: {
          clickid: 30,
          action: 'show',
          elemname: '中奖弹窗',
          type: this.luckInfo.type,
          showTips: this.showTips
        }
      })
      this.setPointerImage(this.drawNum)
      this.isStart = false
      this.isDraw = false
    },
    setPointerImage() {
      this.lotteryConfig.pointerImage = this.finishDrawUrl
      // if (!this.offline) {
      //   if (val > 0) {
      //     this.lotteryConfig.pointerImage = this.luckDrawUrl
      //   } else {
      //     this.lotteryConfig.pointerImage = this.noLuckDrawNumUrl
      //   }
      // } else {
      //   if (!this.isAward) {
      //     this.lotteryConfig.pointerImage = this.finishDrawUrl
      //   } else {
      //     if (val <= 0) {
      //       if (this.isShenhe) {
      //         this.lotteryConfig.pointerImage = this.noShareDrawUrl
      //       } else {
      //         this.lotteryConfig.pointerImage = this.finishDrawUrl
      //       }
      //     } else {
      //       this.lotteryConfig.pointerImage = this.luckDrawUrl
      //     }
      //   }
      // }
    },
    /**
     * 格式化中间弹窗 信息
     */
    setLuckDrawInfo(data) {
      const { alertImage: pic, rewardType: type, rewardName: name } = data
      this.luckInfo = {
        pic,
        type,
        name
      }
    },
    sharePoster() {
      this.$refs.poster.show()
    }
  }
}
</script>
<style lang="less" scoped>
.lottery {
  padding: 10px 57px/2;

  .toast {
    position: absolute;
    top: -65px/2;
    left: 23px/2;
    width: 94%;
    height: 52px/2;
    margin: 0 auto;
    font-size: 24px/2;
    font-weight: 400;
    font-family: FZLanTingHeiS-R-GB;
    line-height: 52px/2;
    text-align: center;
    color: #f8fcfb;
    background: linear-gradient(268deg, #408e71, #74be65);
    border-radius: 26px/2;
  }

  .swiper {
    position: relative;
    width: 523px/2;
    height: 23px;
    background: linear-gradient(90deg, #ffa615, #ffc445);
    border-radius: 11px;
  }

  .wrap {
    position: relative;
    height: 613px/2;
    margin-top: 2px;
  }

  .prizeinfo {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    color: #99571f;
    text-decoration: underline;

    div {
      width: 110px/2;
      height: 30px/2;
      background: url(../../assets/images/myPrize.png) no-repeat;
      background-size: 100% auto;
    }
  }
}
</style>
